module.exports = __webpack_public_path__ + "media/images/login_bg-bdef88e717a06464e61ad9f7c8f126b0.jpg";